// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Fix from "../Specular.FRP.Fix/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var withUniqDynamic_ = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dictEq) {
            return function (dyn) {
                return function (f) {
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.uniqDynBy(dictMonadFRP)(Data_Eq.eq(dictEq))(dyn))(function (uniq) {
                        return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(uniq)(f);
                    });
                };
            };
        };
    };
};
var withRefUniqDynamic_ = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dyn) {
            return function (f) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.uniqDynBy(dictMonadFRP)(Unsafe_Reference.unsafeRefEq)(dyn))(function (uniq) {
                    return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(uniq)(f);
                });
            };
        };
    };
};
var whenD = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dyn) {
            return function (block) {
                return withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data_Eq.eqBoolean)(dyn)(function (b) {
                    return Control_Applicative.when(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(b)(block);
                });
            };
        };
    };
};
var unlessD = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dyn) {
            return function (block) {
                return withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data_Eq.eqBoolean)(dyn)(function (b) {
                    return Control_Applicative.unless(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(b)(block);
                });
            };
        };
    };
};
var uniqDyn = function (dictMonadFRP) {
    return function (dictEq) {
        return Specular_FRP_Base.uniqDynBy(dictMonadFRP)(Data_Eq.eq(dictEq));
    };
};
var sample = function (dictMonadFRP) {
    return function (read) {
        return function (event) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(read))(function (initial) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (update) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(function (v) {
                        return Control_Bind.bind(Effect.bindEffect)(read)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "fire";
                            }
                        })())(Data_Symbol.SProxy.value)(update));
                    })(event))(function () {
                        return Specular_FRP_Base.holdDyn(dictMonadFRP)(initial)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "event";
                            }
                        })())(Data_Symbol.SProxy.value)(update));
                    });
                });
            });
        };
    };
};
var nextJust = function (dictMonadFRP) {
    return function (dyn) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.readDynamic(dictMonadFRP.MonadEffect0())(dyn))(function (currentValue) {
            return Specular_FRP_Base.foldDynMaybe(dictMonadFRP)(function ($$new) {
                return function (old) {
                    if (old instanceof Data_Maybe.Just) {
                        return Data_Maybe.Nothing.value;
                    };
                    if (old instanceof Data_Maybe.Nothing && $$new instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just(new Data_Maybe.Just($$new.value0));
                    };
                    if (old instanceof Data_Maybe.Nothing && $$new instanceof Data_Maybe.Nothing) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at Specular.FRP.Extra (line 97, column 9 - line 100, column 38): " + [ old.constructor.name, $$new.constructor.name ]);
                };
            })(currentValue)(Specular_FRP_Base.changed(dyn));
        });
    };
};
var forWeakDyn_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dictFoldable) {
            return function (dyn) {
                return function (f) {
                    return Specular_FRP_Replaceable.weakDynamic_(dictMonadReplace)(dictMonadFRP)(Data_Functor.map(Specular_FRP_WeakDynamic.functorWeakDynamic)(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(dictFoldable)(f))(dyn));
                };
            };
        };
    };
};
var forDyn_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dictFoldable) {
            return function (dyn) {
                return function (f) {
                    return Specular_FRP_Replaceable.dynamic_(dictMonadReplace)(dictMonadFRP)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(dictFoldable)(f))(dyn));
                };
            };
        };
    };
};
var chain = function (dictMonadWidget) {
    return function (first) {
        return function (second) {
            var fromRightM = function (v) {
                if (v instanceof Data_Either.Left) {
                    return Data_Maybe.Nothing.value;
                };
                if (v instanceof Data_Either.Right) {
                    return new Data_Maybe.Just(v.value0);
                };
                throw new Error("Failed pattern match at Specular.FRP.Extra (line 72, column 3 - line 72, column 50): " + [ v.constructor.name ]);
            };
            var fromLeftM = function (v) {
                if (v instanceof Data_Either.Left) {
                    return new Data_Maybe.Just(v.value0);
                };
                if (v instanceof Data_Either.Right) {
                    return Data_Maybe.Nothing.value;
                };
                throw new Error("Failed pattern match at Specular.FRP.Extra (line 68, column 3 - line 68, column 49): " + [ v.constructor.name ]);
            };
            return Specular_FRP_Fix.fixFRP(Specular_FRP_Fix.fixFRPEvent)(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (fired$prime) {
                return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(Data_Functor.map((((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Functor.map(Specular_FRP_Base.functorEvent)(Data_Either.Left.create))(first))(Data_Functor.map(Specular_FRP_Base.functorEvent)((function () {
                    var $37 = Data_Functor.map((((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Functor.map(Specular_FRP_Base.functorEvent)(Data_Either.Right.create));
                    return function ($38) {
                        return $37(second($38));
                    };
                })())(Specular_FRP_Base.filterMapEvent(fromLeftM)(fired$prime))))(function (v) {
                    return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Extra_Switch.dynamicSwitch(Specular_Extra_Switch.switchEvent)(dictMonadWidget.MonadReplace2())(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(v))(function (v1) {
                        return Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(new Data_Tuple.Tuple(v1, Specular_FRP_Base.filterMapEvent(fromRightM)(v1)));
                    });
                });
            });
        };
    };
};
export {
    forDyn_,
    forWeakDyn_,
    whenD,
    unlessD,
    chain,
    uniqDyn,
    sample,
    nextJust,
    withUniqDynamic_,
    withRefUniqDynamic_
};
//# sourceMappingURL=index.js.map
